<template>
<CLink class="btn-dribbble btn-sm btn mb-2 float-right" @click="click">
    {{ $t('back') }}
    <FaIcon icon="chevron-left" />
</CLink>
</template>

<script>
export default {
    name: 'BackBtn',

    methods: {
        click() {
            this.$emit('click')
        }
    },
}
</script>